(function(angular, module) {var pickerTagListItemController, pickerTagListItemDirective;

pickerTagListItemController = function($scope, $element, tagClassFilter) {
  'ngInject';
  this.tagPicker = $element.controller('dybTagPicker');
  $element.addClass(tagClassFilter(this.tag).join(' '));
  $element.on('mouseenter', (function(_this) {
    return function() {
      return $scope.$apply(function() {
        _this.tagPicker.hoverItem(_this.tag);
      });
    };
  })(this));
  $element.on('click', (function(_this) {
    return function() {
      return $scope.$apply(function() {
        _this.tag.select();
      });
    };
  })(this));
  $scope.$on('tagpicker:activeItemChanged', (function(_this) {
    return function(event, item) {
      $element.toggleClass('active', _this.tag === item);
    };
  })(this));
};

pickerTagListItemDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'util/tags/pickerTagListItem',
    scope: {
      tag: '='
    },
    require: '^dybTagpickerTagList',
    controller: pickerTagListItemController,
    bindToController: true,
    controllerAs: 'ctrl'
  };
};

module.directive('dybTagpickerTagListItem', pickerTagListItemDirective);
})(angular, angular.module("dybTags"));